'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteMessageView', ['NoteMessagesService', '$sce', function (NoteMessagesService, $sce) {
      return {
        restrict: 'A',
        scope: {},
        bindToController: {
          message: '='
        },
        template: '<span class="sa-note-message-content-view" ng-bind-html="::messageViewCtrl.HTMLMessage"></span>',
        controllerAs: 'messageViewCtrl',
        controller: function() {
          var vm = this;

          vm.HTMLMessage = $sce.trustAsHtml(NoteMessagesService.toHTML(vm.message, true));
        }
      };
    }]);
